import { Component } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faCogs, faHeadset, faKey, faKeyboard, faTable, faUser, faWaveformPath } from '@fortawesome/pro-duotone-svg-icons';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { ChangeOwnPasswordState } from 'src/app/store/samwin/change-password/change-own-password.state';
import { RejectChangedSettings, SaveSettings } from 'src/app/store/settings/settings.actions';

@Component({
   selector: 'samweb-global-settings',
   templateUrl: './global-settings.component.html',
   styleUrls: ['./global-settings.component.scss'],
})
export class GlobalSettingsComponent {
   constructor(private store: Store) {}

   public categoryIconCommon = faCogs;
   public categoryIconBrickwall = faTable;
   public categoryIconKeyboard = faKeyboard;
   public categoryIconAudio = faHeadset;
   public categoryIconPassword = faKey;
   public categoryIconAnnouncementPrimary = faUser;
   public categoryIconAnnouncementSecondary = faWaveformPath;

   public saveIcon: IconDefinition = WellKnownIconsEnum.SAVE.icon;
   public cancelIcon: IconDefinition = WellKnownIconsEnum.CANCEL.icon;

   @Select(ChangeOwnPasswordState.canChangeOwnPassword)
   public canChangeOwnPassword$: Observable<boolean>;

   saveSettings() {
      this.store.dispatch(new SaveSettings());
   }

   cancelSettings() {
      this.store.dispatch(new RejectChangedSettings());
   }
}
